import { render } from "./OffCanvas.vue?vue&type=template&id=2ea71e58"
import script from "./OffCanvas.vue?vue&type=script&lang=js"
export * from "./OffCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__